module.exports = __webpack_public_path__ + "img/racksnet_Logo_Weiss_Invers.2f650f82.png";